import MenuSection from './MenuSection';
import Container from './MenuSection.container';

export default Container(MenuSection);
